<arm-layout>
  <div main>
    <div class="device-location-form">
      <arm-form (submitForm)="onSubmit()" [disableSubmit]="isUnauthorized">

        <arm-form-title>ovoc phones synchronization</arm-form-title>

        <mat-checkbox [(ngModel)]="deviceLocation.enabled" class="example-margin" color="primary" name="enabled">Enable
          synchronization
        </mat-checkbox>

        <div class="properties">
          <div>
            <mat-form-field class="longer-width">
              <mat-label>OVOC Matching property</mat-label>
              <mat-select [(ngModel)]="ovocMatchingProp" [disabled]="true" [placeholder]="ovocMatchingProp">
                <mat-option value="phoneNumber">phoneNumber</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="property-value-right">
            <mat-form-field class="longer-width">
              <mat-label>ARM Matching property</mat-label>
              <mat-select (selectionChange)="updateAttributesOptions()" [(ngModel)]="deviceLocation.matchingPropertyId" [disabled]="false"
                          name="matchingId">
                <mat-option></mat-option>
                <mat-option *ngFor="let item of matchingPropertyIdOptions" [value]="item.id">
                  {{item.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

        </div>
        <div class="properties">
          <div>
            <mat-form-field class="longer-width">
              <mat-label>OVOC location property</mat-label>
              <mat-select [(ngModel)]="ovocLocationProp" [disabled]="true" [placeholder]="ovocLocationProp">
                <mat-option value="locationMatch">locationMatch</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="property-value-right">
            <mat-form-field class="longer-width">
              <mat-label>ARM location property</mat-label>
              <mat-select (selectionChange)="updateAttributesOptions()" [(ngModel)]="deviceLocation.locationPropertyId"
                          name="locationPropertyId">
                <mat-option></mat-option>
                <mat-option *ngFor="let item of locationPropertyIdOptions" [value]="item.id">
                  {{item.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <arm-form-title>regular synchronization</arm-form-title>

        <div class="regular-sync">
          <mat-form-field class="longer-width">
            <mat-label>Check for updates every (min)</mat-label>
            <input [(ngModel)]="deviceLocation.syncIntervalMinutes" matInput max="1440"
                   min="1" name="syncIntervalMinutes" type="number">
          </mat-form-field>

          <div class="regular-sync-timestamp">
            <mat-label class="regular-sync-timestamp-label">Last update:</mat-label>
            <span class="timestamp">{{deviceLocation.lastSyncTimestamp != null? (deviceLocation.lastSyncTimestamp| date:'M/d/yy, HH:mm:ss zzzz')
              :'N/A'}}</span>
          </div>
        </div>

        <arm-form-title>full synchronization</arm-form-title>

        <div class="full-sync">
          <mat-form-field class="longer-width">
            <mat-label>Perform full update every (days)</mat-label>
            <input [(ngModel)]="deviceLocation.fullSyncIntervalInDays" matInput max="365"
                   min="1" name="fullSyncIntervalInDays" type="number">
          </mat-form-field>

          <div class="full-sync-timestamp">
           <div class="full-sync-timestamp-label">
              <mat-label>Last full update:</mat-label>
           </div>
            <span class="timestamp">{{deviceLocation.lastFullSyncTimestamp != null? (deviceLocation.lastFullSyncTimestamp| date:'M/d/yy, HH:mm:ss zzzz')
              :'N/A'}}</span>
          </div>
        </div>

        <div class="full-sync-at">
          <div class="full-sync-at-hours">
            <mat-form-field class="longer-width">
              <mat-label>At hour</mat-label>
              <input [(ngModel)]="deviceLocation.fullSyncHour" matInput max="23"
                     min="1" name="fullSyncHour" type="number">
            </mat-form-field>
          </div>
          <div class="full-sync-at-minutes">
            <mat-form-field class="longer-width">
              <mat-label>At minute of the hour</mat-label>
              <input [(ngModel)]="deviceLocation.fullSyncMinute" matInput max="59"
                     min="0" name="fullSyncMinute" type="number">
            </mat-form-field>
          </div>
        </div>
      </arm-form>
    </div>
  </div>
</arm-layout>



